import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';

import { AuthGuard } from './shared/helpers/auth.guard';

const routes: Routes = [
    { 
        path: 'login', 
        component: LoginComponent 
    },
    { 
        path: '', 
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard] 
    },
    {   
        path: 'edit-candidate/:id',
        loadChildren: () =>
            import('./edit-candidate-details/edit-candidate-details.module').then(m => m.EditCandidateDetailsModule),
        canActivate: [AuthGuard] 
    },
    {
        // Adding new candidates is permanently disabled.
        path: 'add-candidate',
        redirectTo: '',
    },
    { 
        path: 'candidate-list', 
        loadChildren: () =>
            import('./candidate-details/candidate-details.module').then(m => m.CandidateDetailsModule), 
        canActivate: [AuthGuard] 
    },
    { 
        path: 'view-pipeline', 
        loadChildren: () => 
            import('./candidate-pipeline/candidate-pipeline.module').then(m => m.CandidatePipelineModule), 
        canActivate: [AuthGuard] 
    },
    { 
        path: 'search-candidate', 
        loadChildren: () =>
            import('./candidate-search/candidate-search.module').then(m => m.CandidateSearchModule),
        canActivate: [AuthGuard] 
    },
    {
        path: 'positions',
        loadChildren: () =>
            import('./positions/positions.module').then(m => m.PositionsModule),
        canActivate: [AuthGuard] 
    },
    {
        path: 'metrics',
        loadChildren: () =>
            import('./metrics/metrics.module').then(m => m.MetricsModule),
        canActivate: [AuthGuard] 
    },
    {
        path: '**',
        redirectTo: '',
    },
];

export const appRoutingModule = RouterModule.forRoot(routes, {
  // FIX: Remove PreloadAllModules to restore true lazy loading
  // This reduces initial bundle by 400-500KB and improves FCP/LCP
});
